import styled from '@emotion/styled'
import { isMobile } from '@const/device'

export const Wrapper = styled.div`
  width: ${() => (isMobile ? '100%' : '200px')};
`
